export const formatDiscount = (discountPct: number) => {
  return `${Math.ceil(discountPct)}%`;
};
